import { http } from '@shared/api';
import type { ManufacturerProfile, UpdateProfileRequest } from '../model/types';

export const manufacturerApi = {
  getProfile: () => http.get('manufacturer/profile').json<ManufacturerProfile>(),
  updateProfile: (body: UpdateProfileRequest) =>
    http.put('manufacturer/profile', { json: body }).json<ManufacturerProfile>(),
  submitKyc: () => http.post('manufacturer/profile/submit-kyc').json<ManufacturerProfile>(),
};
